import { Component, Inject, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';
import { LocationUserInfo } from 't4core';
import { LocationGroupInfo, LocationInfo, ProductType } from '../../../../../projects/t4core/src/public-api';

@Component({
  selector: 'CreatePricelistDialog',
  templateUrl: 'CreatePricelistDialog.html',
})
export class CreatePricelistDialog extends DialogBase implements OnInit {
  public type: ProductType = ProductType.RentalObject;
  public childGroups: LocationGroupInfo[];
  public childLocations: LocationInfo[];
  public isChild: number = 0;
  public childId: Number;
  public isLoading: boolean = false;

    constructor(
      public dialogRef: MatDialogRef<CreatePricelistDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      super("CreatePricelistDialog");
      this.isChild = data.isChild;
  }

  public async ngOnInit() {
    this.isLoading = true;
    if (this.isChild == 1) {      
      this.childGroups = await this.Api.get("Settings/GetChildGroups");
    }
    else if (this.isChild == 2) {
      this.childLocations = await this.Api.get("Settings/GetChildLocations");
    }
    this.isLoading = false;
  }

  public async create() {
    var token = this.beginLoad("T4.Settings.CreatePricelistDialog.msgCreating", "Creating pricelist", null);
    await this.Api.put("Settings/CreatePricelist", null, { type: this.type, childId: this.childId });
    this.endLoad(token);

    this.dialogRef.close(this.type);
  }
}
